import { render, staticRenderFns } from "./addDictItem.vue?vue&type=template&id=676a3094&"
import script from "./addDictItem.vue?vue&type=script&lang=js&"
export * from "./addDictItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports